module.exports = __webpack_public_path__ + "img/gauge-min.5ae66ae6.svg";